import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/auth/login/Login';
import ForgotPassword from '../pages/auth/forgotpassword/ForgotPassword';
import Signup from '../pages/auth/signup/Signup';
import CreateNewPassword from '../pages/auth/createNewPassword/CreateNewPassword';
import OTPVerify from '../pages/auth/otpVerify/OTPVerify';
import Layout from '../layout/Layout';
import Dashboard from '../pages/dashboard';
import OrganizationDetail from '../pages/organizationDetail/OrganizationDetail';
import PrivateRoute from './PrivateRoutes';
import ProductDetails from '../pages/inventory/product';
import ProductGroup from '../pages/inventory/product/productGroup/ProductGroup';
import Adjustment from '../pages/inventory/adjustment';
import InventoryAdjustment from '../pages/inventory/adjustment/InventoryAdjustment';
import NotFound from '../pages/404NotFound';
import CreateProduct from '../pages/inventory/product/addProduct/CreateProduct';
import GroupDetails from '../pages/inventory/product/productGroup/GroupDetails';
import Vendors from '../pages/vendors/Vendors';
import CreateVendors from '../pages/vendors/CreateVendors';
import PurchaseOrder from '../pages/purchaseOrder/PurchaseOrder';
import PurchaseReceived from '../pages/PurchaseRecieved/PurchaseReceived';
import CreatePurchaseReceive from '../pages/PurchaseRecieved/CreatePurchaseReceive';
import PurchaseBills from '../pages/purchasebills/PurchaseBills';
import PurchaseBillDetails from '../pages/purchasebills/PurchaseBillDetails';
import CreditNote from '../pages/creditNote/CreditNote';
import CreditNoteDetails from '../pages/creditNote/CreditNoteDetails';
import CreateCreditNote from '../pages/creditNote/CreateCreditNote';
import PaymentMade from '../pages/paymentMade/PaymentMade';
import PaymentMadeDetails from '../pages/paymentMade/PaymentMadeDetails';
import CreatePaymentMade from '../pages/paymentMade/CreatePaymentMade';
import CreatePurchaseBill from '../pages/purchasebills/CreatePurchaseBill';
import PurchaseOrderSendEmails from '../pages/purchaseOrder/PurchaseOrderSendEmails';
import PurchaseOrderDetails from '../pages/purchaseOrder/PurchaseOrderDetails';
import PurchaseReceiveDetails from '../pages/PurchaseRecieved/PurchaseReceiveDetails';
import CreatePurchaseOrder from '../pages/purchaseOrder/CreatePurchaseOrder';
import PurchaseReceiveSendEmail from '../pages/PurchaseRecieved/PurchaseReceiveSendEmail';
import Customers from '../pages/v2/sales/customers/customers';
import CustomersDetails from '../pages/v2/sales/customers/customerDetails';
import PurchaseMadeSendEmail from '../pages/paymentMade/PaymentMadeSendEmail';
import CreditNoteSendEmail from '../pages/creditNote/CreditNoteSendEmail';
import CreateCustomer from '../pages/v2/sales/customers/createCustomer';
import Doctors from '../pages/v2/sales/doctors/doctors';
import CreateDoctor from '../pages/v2/sales/doctors/createDoctor';
import DoctorDetails from '../pages/v2/sales/doctors/doctorDetails';
import Invoice from '../pages/v2/sales/invoice/invoice';
import CreateInvoice from '../pages/v2/sales/invoice/createInvoice';
import InvoiceDetails from '../pages/v2/sales/invoice/invoiceDetails';
import InvoiceSendEmails from '../pages/v2/sales/invoice/components/invoiceSendEmails';
import InvoiceSharedLinkPdfView from '../pages/v2/sales/invoice/invoiceDetails/shareLink/invoiceSharedLinkPdfView';
import PaymentReceived from '../pages/v2/sales/paymentReceieved';
import CreatePaymentReceived from '../pages/v2/sales/paymentReceieved/createPaymentReceieved';
import PaymentReceivedDetails from '../pages/v2/sales/paymentReceieved/paymentReceivedDetails';
import PaymentReceivedSendEmail from '../pages/v2/sales/paymentReceieved/components/paymentRecievedSendEmail';
import SalesReturn from '../pages/v2/sales/salesReturn';
import CreateSalesReturn from '../pages/v2/sales/salesReturn/createSalesReturn';
import SalesReturnDetails from '../pages/v2/sales/salesReturn/salesReturnDetails';
import SalesReturnSendEmail from '../pages/v2/sales/salesReturn/components/salesReturnSendEmail';
import SalesCreditNote from '../pages/v2/sales/credit_note';
import SalesCreateCreditNote from '../pages/v2/sales/credit_note/createCreditNote';
import SalesCreditNoteDetails from '../pages/v2/sales/credit_note/credit_note_details';
import SalesCreditNoteSendEmail from '../pages/v2/sales/credit_note/components/creditNoteSendEmail';
import Settings from '../pages/v2/settings';

export const Approuter = createBrowserRouter([
	{
		path: '/',
		element: <Login />,
	},
	{
		path: `/forgotPassword`,
		element: <ForgotPassword />,
	},
	{
		path: '/signup',
		element: <Signup />,
	},
	{
		path: '/createNewPassword',
		element: <CreateNewPassword />,
	},
	{
		path: '/otpVerify/*',
		element: <OTPVerify />,
	},
	{
		path: '/organizationDetail',
		element: <OrganizationDetail />,
	},
	{
		path: '/sales/invoices/share/:id?',
		element: <InvoiceSharedLinkPdfView />,
	},
	{
		path: '/user',
		element: <PrivateRoute element={<Layout />} />,
		children: [
			{
				path: `/user/:suburl?/:suburl?/home`,
				element: <PrivateRoute element={<Dashboard />} />,
			},
			{
				path: '/user/:suburl?/product/:id?',
				element: <PrivateRoute element={<ProductDetails />} />,
			},
			{
				path: '/user/:suburl?/product-create/:id?',
				element: <PrivateRoute element={<CreateProduct />} />,
			},
			{
				path: '/user/:suburl?/group',
				element: <PrivateRoute element={<ProductGroup />} />,
			},
			{
				path: '/user/:suburl?/group-details/:id',
				element: <PrivateRoute element={<GroupDetails />} />,
			},
			{
				path: '/user/:suburl?/inventory-adjustment-crete/:id?',
				element: <PrivateRoute element={<Adjustment />} />,
			},
			{
				path: '/user/:suburl?/inventory-adjustment',
				element: <PrivateRoute element={<InventoryAdjustment />} />,
			},
			{
				path: '/user/:suburl?/vendor',
				element: <PrivateRoute element={<Vendors />} />,
			},
			{
				path: '/user/:suburl?/vendor-create/:id?',
				element: <PrivateRoute element={<CreateVendors />} />,
			},

			{
				path: '/user/:suburl?/purchases-order',
				element: <PrivateRoute element={<PurchaseOrder />} />,
			},
			{
				path: '/user/:suburl?/purchases-order-details/:id',
				element: <PrivateRoute element={<PurchaseOrderDetails />} />,
			},

			{
				path: '/user/:suburl?/purchases-order-create/:id?',
				element: <PrivateRoute element={<CreatePurchaseOrder />} />,
			},
			{
				path: '/user/:suburl?/purchases-order-edit/:id?',
				element: <PrivateRoute element={<CreatePurchaseOrder />} />,
			},
			{
				path: '/user/:suburl?/purchases-order-send-emails/:id',
				element: <PrivateRoute element={<PurchaseOrderSendEmails />} />,
			},
			{
				path: '/user/:suburl?/purchases-receive-send-emails/:id',
				element: <PrivateRoute element={<PurchaseReceiveSendEmail />} />,
			},
			{
				path: '/user/:suburl?/credit-note-send-emails/:id',
				element: <PrivateRoute element={<CreditNoteSendEmail />} />,
			},
			{
				path: '/user/:suburl?/payment-made-send-emails/:id',
				element: <PrivateRoute element={<PurchaseMadeSendEmail />} />,
			},

			{
				path: '/user/:suburl?/purchases-receive',
				element: <PrivateRoute element={<PurchaseReceived />} />,
			},
			{
				path: '/user/:suburl?/purchases-receive-details/:id?',
				element: <PrivateRoute element={<PurchaseReceiveDetails />} />,
			},
			{
				path: '/user/:suburl?/purchases-receive-create/:id?',
				element: <PrivateRoute element={<CreatePurchaseReceive />} />,
			},

			{
				path: '/user/:suburl?/purchases-bills',
				element: <PrivateRoute element={<PurchaseBills />} />,
			},
			{
				path: '/user/:suburl?/purchases-bills-details/:id?',
				element: <PrivateRoute element={<PurchaseBillDetails />} />,
			},
			{
				path: '/user/:suburl?/purchases-bills-create/:id?',
				element: <PrivateRoute element={<CreatePurchaseBill />} />,
			},

			{
				path: '/user/:suburl?/payment-made',
				element: <PrivateRoute element={<PaymentMade />} />,
			},
			{
				path: '/user/:suburl?/payment-made-details/:id?',
				element: <PrivateRoute element={<PaymentMadeDetails />} />,
			},
			{
				path: '/user/:suburl?/payment-made-create/:id?',
				element: <PrivateRoute element={<CreatePaymentMade />} />,
			},

			{
				path: '/user/:suburl?/credit-note',
				element: <PrivateRoute element={<CreditNote />} />,
			},
			{
				path: '/user/:suburl?/credit-note-details/:id?',
				element: <PrivateRoute element={<CreditNoteDetails />} />,
			},
			{
				path: '/user/:suburl?/credit-note-create/:id?',
				element: <PrivateRoute element={<CreateCreditNote />} />,
			},
			{
				path: '/user/:suburl?/customers',
				element: <PrivateRoute element={<Customers />} />,
			},

			{
				path: '/user/:suburl?/customers-create/:id?',
				element: <PrivateRoute element={<CreateCustomer />} />,
			},
			{
				path: '/user/:suburl?/customers-details/:id?',
				element: <PrivateRoute element={<CustomersDetails />} />,
			},

			{
				path: '/user/:suburl?/doctors',
				element: <PrivateRoute element={<Doctors />} />,
			},
			{
				path: '/user/:suburl?/doctors-create/:id?',
				element: <PrivateRoute element={<CreateDoctor />} />,
			},
			{
				path: '/user/:suburl?/doctors-details/:id?',
				element: <PrivateRoute element={<DoctorDetails />} />,
			},
			{
				path: '/user/:suburl?/invoices',
				element: <PrivateRoute element={<Invoice />} />,
			},
			{
				path: '/user/:suburl?/invoices-create/:id?',
				element: <PrivateRoute element={<CreateInvoice />} />,
			},
			{
				path: '/user/:suburl?/invoice-send-emails/:id',
				element: <PrivateRoute element={<InvoiceSendEmails />} />,
			},
			{
				path: '/user/:suburl?/invoices-details/:id?',
				element: <PrivateRoute element={<InvoiceDetails />} />,
			},
			{
				path: '/user/:suburl?/payments-received',
				element: <PrivateRoute element={<PaymentReceived />} />,
			},
			{
				path: '/user/:suburl?/payments-received-create/:id?',
				element: <PrivateRoute element={<CreatePaymentReceived />} />,
			},
			{
				path: '/user/:suburl?/payments-received-details/:id?',
				element: <PrivateRoute element={<PaymentReceivedDetails />} />,
			},
			{
				path: '/user/:suburl?/payments-received-send-emails/:id',
				element: <PrivateRoute element={<PaymentReceivedSendEmail />} />,
			},
			{
				path: '/user/:suburl?/sales-return',
				element: <PrivateRoute element={<SalesReturn />} />,
			},
			{
				path: '/user/:suburl?/sales-return-create/:id?',
				element: <PrivateRoute element={<CreateSalesReturn />} />,
			},

			{
				path: '/user/:suburl?/sales-return-details/:id?',
				element: <PrivateRoute element={<SalesReturnDetails />} />,
			},
			{
				path: '/user/:suburl?/sales-return-send-emails/:id',
				element: <PrivateRoute element={<SalesReturnSendEmail />} />,
			},
			{
				path: '/user/:suburl?/sales/credit-note',
				element: <PrivateRoute element={<SalesCreditNote />} />,
			},
			{
				path: '/user/:suburl?/sales/credit-note-create/:id?',
				element: <PrivateRoute element={<SalesCreateCreditNote />} />,
			},
			{
				path: '/user/:suburl?/sales/credit-note-details/:id?',
				element: <PrivateRoute element={<SalesCreditNoteDetails />} />,
			},
			{
				path: '/user/:suburl?/sales/credit-note-send-emails/:id',
				element: <PrivateRoute element={<SalesCreditNoteSendEmail />} />,
			},
			{
				path: '/user/:suburl?/settings/:type?',
				element: <PrivateRoute element={<Settings />} />,
			},

			{
				path: '*',
				element: <NotFound />,
			},
		],
	},
]);
